import { useFormContext, useWatch } from '../../../../../../../../../hooks'
import type { ReviewEntryDataFormSchema } from '../../../../../../../types/getReviewEntryDataFormSchema'

export const useReviewEntryLineItemTotals = () => {
  const { control } = useFormContext<ReviewEntryDataFormSchema>()
  const entryLines = useWatch({ control, name: 'entryLines' }) ?? []

  const totalAmountExclVat = entryLines.reduce((sum, line) => sum + (line.amountExclVat ?? 0), 0)
  const totalAmountInclVat = entryLines.reduce((sum, line) => sum + (line.amountInclVat ?? 0), 0)
  const totalVatAmount = entryLines.reduce((sum, line) => sum + (line.vatAmount ?? 0), 0)

  return { totalAmountExclVat, totalAmountInclVat, totalVatAmount }
}
